/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Solitaire/MvvmStructure/Service/ManifestService',[
    'jszip',
    'jsziputils',
    'gameconfig'
], function (JSZip, JSZipUtils, GameConfig) {
    "use strict";

    var ManifestService = {

        _manifestURLBase: GameConfig.manifest.baseURL,
        _contentManifestURL: GameConfig.manifest.contentManifestURL,

        _manifest: null,
        _contentManifest: null,
        _contentManifestBaseUrl: null,
        _secondaryManifests: {},
        _secondaryManifestsBaseUrl: {},

        GetManifestURL: function () {
            // Number.MAX_SAFE_INTEGER does not exist in IE11.
            return this._manifestURLBase += "&timestamp=" + new Date().getTime() + "&random=" + Math.floor(Math.random() * 9007199254740991);
        },

        GetContentManifestURL: function () {
            return this._contentManifestURL;
        },

        Load: function (onSuccess, onError) {
            JSZipUtils.getBinaryContent(this.GetManifestURL(), function(err, data) {
                if (err) {
                    onError(err);
                }

                try {
                    JSZip.loadAsync(data).then(function(zip) {
                        zip.file("manifest.js").async("string").then(function(content) {
                            this.SetManifest(content);

                            if (this._manifest && this._contentManifest) {
                                onSuccess();
                            }
                        }.bind(this));
                    }.bind(this));
                } catch (e) {
                    onError(e)
                }

            }.bind(this));

            fetch(this.GetContentManifestURL())
                .then((res) => {
                    this._contentManifestBaseUrl = res.url.substring(0, res.url.lastIndexOf("/"));
                    return res.json();
                })
                .then((out) => {
                    if (!out.RelativeSecondaryManifestPath.startsWith("/")) {
                        this._contentManifestBaseUrl += "/"
                    }

                    this._contentManifestBaseUrl += out.RelativeSecondaryManifestPath;

                    if (!this._contentManifestBaseUrl.endsWith("/")) {
                        this._contentManifestBaseUrl += "/"
                    }

                    this._contentManifest = out;

                    // We could loop and load all secondary manifests but we just want dailychallenges for now.
                    this.LoadSecondaryManifest( "dailychallenges" );

                    if (this._manifest && this._contentManifest) {
                        onSuccess();
                    }
                }).catch( err => onError(err) );
        },

        LoadSecondaryManifest: function (content) {
            if (!this._contentManifest || !this._contentManifest.Items) {
                return;
            }

            for (const item of this._contentManifest.Items) {
                if (item.Key == content) {

                    var url = item.Path;
                    var isAbsoluteUrl = url.toLowerCase().indexOf('http://') === 0 || url.toLowerCase().indexOf('https://') === 0;
                    if (!isAbsoluteUrl) {
                        url = this._contentManifestBaseUrl + item.Path;
                    }

                    fetch(url)
                        .then((res) => {
                            var baseUrl = res.url.substring(0, res.url.lastIndexOf("/"));
                            this._secondaryManifestsBaseUrl[content] = baseUrl;
                            return res.json();
                        })
                        .then((out) => {
                            // Prepend baseUrl to all content entries
                            for (const category of out.categories)
                            {
                                for (const entry of category.entries)
                                {
                                    entry.name = this._secondaryManifestsBaseUrl[content] + "/" + entry.name;
                                }
                            }

                          this._secondaryManifests[content] = out;
                      });

                }
            }
        },

        SetManifest: function (text) {
            this._manifest = JSON.parse(text);
        },

        GetSettings: function (group, key) {

            if (!this._manifest || !this._manifest.Settings) {
                return null;
            }

            for (var gi = 0; gi < this._manifest.Settings.length; gi++) {
                var g = this._manifest.Settings[gi];

                if (g.Group == group) {
                    for (var i = 0; i < g.Items.length; i++) {
                        var item = g.Items[i];
                        if (item.Key == key) {
                            return item;
                        }
                    }
                }
            }

            return null;
        },

        GetContentCategoryEntry: function (content, category, key) {

            if (!this._secondaryManifests[content] || !this._secondaryManifests[content].categories) {
                return null;
            }

            for (const a_category of this._secondaryManifests[content].categories) {
                if (a_category.name == category)
                {
                    for (const entry of a_category.entries)
                    {
                        if (entry.key == key)
                        {
                            return entry;
                        }
                    }
                }
            }

            return null;
        },

        IsValid: function () {
            return this._manifest != null;
        }

    };

    return ManifestService;


});

